
import { getAreaStr, richTextImg, richTextWrap } from '@/common/js/utils'
export const queryDetailMixin = {
  data () {
    return {
      tabPage: 0,
      info: {
        bannerList: []
      }, // 景点/商户详情
      proList: [], // 产品列表
      attentionDialogVisible: false, // 弹窗
      attentionContent: null,
      banners: [], // 轮播
      bannerActiveIdx: 0,
      bannerIdx: 0,
      moveLeft: 0,
      imgHeight: 193 // 171+20
    }
  },
  created () {
    this.id = this.$route.query.id
    if (this.moduleType === 'HOTEL') {
      this.loadBedType()
    }
    this.loadInfo()
  },
  methods: {
    // 切换
    handleTab (type) {
      this.isSupportDelivery = type
      this.loadProducts(this.id)
    },
    // tab切换
    handleTabPage (index) {
      this.tabPage = index
      this.loadProducts(this.id)
    },
    // banner选择
    bannerChange (idx) {
      this.bannerActiveIdx = idx
      if (idx === 0) { // 全部
        this.banners = []
        this.info.bannerList.forEach(item => {
          this.banners = [...this.banners, ...item.imgList]
        })
      } else {
        this.banners = this.info.bannerList[idx - 1].imgList
      }
      this.bannerIdx = 0
      this.moveLeft = 0
    },
    bannerIdxSel (idx) {
      this.$refs.carousel.setActiveItem(idx)
    },
    handleBannerPrev () {
      if (this.banners.length <= 6 || this.moveLeft === 0) {
        return
      }
      this.moveLeft -= this.imgHeight
    },
    handleBannerNext () {
      if (this.banners.length <= 6 || this.moveLeft === (this.banners.length - 6) * this.imgHeight) {
        return
      }
      this.moveLeft += this.imgHeight
    },
    // 预订须知
    handleTips (content) {
      this.attentionContent = richTextImg(content)
      this.attentionDialogVisible = true
    },
    // 景点/商户数据处理
    loadIndustryOrMerchData (obj) {
      const areaStr = getAreaStr(obj.addressProvinceCode, obj.addressCityCode, obj.addressCountyCode)
      obj.addressDetails = areaStr + obj.addressDetails
      obj.level = Number(obj.level)
      obj.introduce = richTextImg(obj.introduce) || '暂无'
      obj.trafficGuide = richTextWrap(obj.trafficGuide) || '暂无'
      obj.bannerList = []
      obj.bannerTotalNum = 0
      const pictures = obj.pictures ? JSON.parse(obj.pictures) : []
      pictures.forEach(item => {
        if (item.index !== 1) {
          item.imgList = item.url.split(',')
          obj.bannerTotalNum += item.imgList.length
          obj.bannerList.push(item)
        }
      })
      obj.upname = obj.name.substring(0, 8)
      obj.downname = obj.name.substring(8)
      this.info = obj
      this.bannerChange(0)
      if (this.moduleType !== 'TRIP') {
        this.loadProducts(this.id)
      }
    },
    // 产品列表数据处理
    loadList (list) {
      this.proList = list.map(item => {
        const pictures = JSON.parse(item.goodsPicture)
        item.mainPic = pictures.find(pic => pic.index === 1).url
        item.goodsTargetThumbnail = pictures.find(pic => pic.index === 1).url
        if (this.moduleType === 'HOTEL') {
          item.bedShapeInformationStr = this.bedShapeInformationDeal(item.bedShapeInformation)
        }
        if (this.moduleType === 'RETAIL') {
          if (item.specificationItems == null) item.specificationItems = []
          item = this.handleChooseSpec(item)
        }
        return item
      })
    }
  }
}
